import { CONTACT_INFO_SET_DATA } from "src/redux/actions/contactInfo";

export interface ContactI {
  name: string;
  number: string;
}

export type ContactInfoAction = {
  type: typeof CONTACT_INFO_SET_DATA;
  payload: ContactI[];
};

const contactInfo = (state: ContactI[] = null, action: ContactInfoAction) => {
  switch (action.type) {
    case CONTACT_INFO_SET_DATA:
      return action.payload;
    default:
      return state;
  }
};

export default contactInfo;
